import axios from 'axios';

const API = axios.create({
    baseURL: '/api/',
    withCredentials: true,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// request interceptor: اضف التوكن عند كل طلب (إذا موجود)
API.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            delete config.headers.Authorization;
        }
        return config;
    },
    error => Promise.reject(error)
);

// response interceptor: تعامل مع 401/403 بنفس طريقة المشروع
API.interceptors.response.use(
    response => response,
    error => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // allow callers to opt out of automatic redirect by setting config.skipAuthRedirect = true
            const skip = error.config && error.config.skipAuthRedirect;
            if (!skip) {
                try { localStorage.removeItem('token'); } catch (e) {}
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default API;
